<template>
  <button
    type="button"
    class="tw-mx-2 tw-rounded-full tw-border-none tw-bg-primary-grey-100/0 tw-text-primary-grey-950 tw-outline-none tw-ring-4 tw-ring-primary-grey-100/0 tw-transition-all hover:tw-cursor-pointer hover:tw-bg-primary-grey-100 hover:tw-text-primary-grey-950 hover:tw-ring-primary-grey-100 active:tw-bg-primary-grey-200 active:tw-ring-primary-grey-200 dark:hover:tw-bg-primary-grey-200 dark:hover:tw-ring-primary-grey-200 dark:active:tw-bg-primary-grey-100 dark:active:tw-ring-primary-grey-100"
    @click="emitClick"
  >
    <ClIconTablerIconEye :width="'18'" :height="'18'" />
  </button>
</template>

<script lang="ts" setup>
import { ClIconTablerIconEye } from "../icons";

const emit = defineEmits<{
  (event: "on-click"): void;
}>();

const emitClick = (): void => {
  emit("on-click");
};
</script>

<style scoped></style>
